import { Component, OnInit } from "@angular/core";
import { DonutChartService } from "@app/shared/component/donut-chart/donut-chart.service";

@Component({
  selector: "app-donut-chart",
  templateUrl: "donut-chart.component.html",
  providers: [DonutChartService]
})
export class DonutChartComponent implements OnInit {
  chartDonutData = {};

  chartDonutOptions = {
    colors: ["#4099ff", "#2ed8b6", "#FFB64D", "#FF5370", "#6c74cf"],
    formatter: (y, data) => {
      return `$${y}`;
    }
  };

  constructor(private donutService: DonutChartService) {
    this.donutService.getEarnings().subscribe({
      next: data => {
        // console.log(data);
        this.chartDonutData = data;
      }
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/component/donut-chart/donut-chart.component.ts